import React from 'react';
import {Divider, IconButton, Tooltip} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {Vendor} from 'pwm-shared/src/types';
import {PWMCard, PWMCardContent, PWMCardHeader} from 'src/PWM/components/PWMCard';
import {PWMRefreshIcon, PWMVerifiedIcon, PWMViewIcon, PWMWarningIcon} from 'src/PWM/components/PWMIcons';
import {PWMPropertyList, PWMPropertyListItem} from 'src/PWM/components/PWMPropertyList';
import {formatDate} from 'src/PWM/utils/date-utils';
import {SubText} from 'src/PWM/components/PWMTypography';
import {tokens} from 'src/PWM/locales/tokens';
import Validations from './Validations';

const RegistrationCard: React.FC<IPWMRegistrationCardProps> = (props) => {
  const {
    title, url, verified = false, refresh = () => { /* */
    }, setIsLoading,
    idNo, from, to, lastVerified, message, registrations, warning= false, validations = [], vendor
  } = props;
  const {t} = useTranslation();
  const color = verified ? 'primary' : 'error';
  const align = 'horizontal';
  return (
    <PWMCard>
      <PWMCardHeader
        title={title}
        subheader={lastVerified && `${t(tokens.interface.lastverified)}: ${formatDate(lastVerified)}`}
        avatar={<>
          <Tooltip title={`${t(tokens.interface.vendor)} ${verified ? 'is' : 'not'} ${t(tokens.interface.verified)}`}>
            <PWMVerifiedIcon color={color} />
          </Tooltip>
          {warning && <PWMWarningIcon color="error" />}
        </>}
        action={[
          <IconButton title={`${t(tokens.interface.refresh)} ${title} ${t(tokens.interface.information)}`} onClick={refresh}>
            <PWMRefreshIcon />
          </IconButton>,
          <IconButton title={`${t(tokens.interface.view)} ${title}`} href={`https://href.li/?${url}`} target="_blank" referrerPolicy="no-referrer">
            <PWMViewIcon />
          </IconButton>
        ]} />
      <PWMCardContent>
        <PWMPropertyList>
          <PWMPropertyListItem
            label={`${t(tokens.interface.id)}`}
            value={idNo}
            align={align}
          />
          <PWMPropertyListItem
            label={`${t(tokens.interface.effective)}:`}
            align={align}
            value={`${formatDate(from)} - ${formatDate(to)}`}
          />
          <PWMPropertyListItem
            label={`${t(tokens.interface.registrations)}:`}
            align={align}
          >
            {registrations?.map(({name}) => <SubText key={name}>{name}</SubText>)}
          </PWMPropertyListItem>
          {message && (
            <PWMPropertyListItem
              label={`${t(tokens.interface.message)}`}
              align={align}
              value={message}
            />
          )}
        </PWMPropertyList>
      </PWMCardContent>
      {validations && <>
        <Divider />
        <PWMCardHeader title={`${t(tokens.interface.verificationhistory)}`} />
        <PWMCardContent>
          <Validations
            vendorName={vendor}
            sys={title}
            data={validations}
            setBusy={setIsLoading}
          />
        </PWMCardContent>
      </>
      }
    </PWMCard>
  );
};

export default RegistrationCard;

interface IPWMRegistrationCardProps {
  title: string;
  vendor: string;
  idNo: string;
  from: Date;
  to: Date;
  lastVerified: Date;
  url: string;
  message?: string;
  verified?: boolean;
  warning?: boolean;
  registrations?: { name: string; link?: string; }[];
  validations?: Vendor.GetVendorValidations[];
  refresh?(): any;
  setIsLoading(isLoading: boolean): any;
  children?: React.ReactNode;
}